module.exports = __webpack_public_path__ + "img/29-image-2@2x.bfc0c758.png";